import React from 'react';
import TemplateBanner from './TemplateBanner.js';
import TemplateSidebar from './TemplateSidebar.js';

const MainPageTemplate = ({ children }) => (
  <div className="content-pane d-flex flex-column">
      <div className="page-top">
        <TemplateBanner/>
        <div className="spacer"></div>
      </div>
      <div className="container page-center d-flex align-items-stretch flex-grow-1">
        <TemplateSidebar/>
        <div className="page-content d-flex flex-column justify-content-center flex-grow-1">
          {children}
        </div>
      </div>
        <div className="page-bottom">
        <div className="spacer"></div>
        <div className="footer"></div>
      </div>
    </div>
);

export default MainPageTemplate



// WEBPACK FOOTER //
// ./src/MainPageTemplate.js